// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__kPxDu","row":"Node_row__1exN_","label":"Node_label__2L3cK","footer":"Node_footer__3OGQ4"};